<template>
  <div class="remote_sims">
    <div
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="remote_sims__header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="filters">
        <div class="form_select">
          <fg-input
              type="text"
              v-model="filter.fid"
              :placeholder="translate('sim_server.device_fid')"
              :label="translate('sim_server.device_fid')"
              :clearable="true"
              @input="change_input"
          />
        </div>
        <div class="form_select">
          <fg-input
              type="text"
              v-model="filter.iccid"
              :placeholder="translate('sim_server.iccid')"
              :label="translate('sim_server.iccid')"
              :clearable="true"
              @input="change_input"
          />
        </div>
        <div class="form_select"></div>
        <div class="form_select"></div>
      </div>

      <div class="buttons">
        <button
            class="btn btn-success btn-fill text-center"
            @click.prevent="update_status"
        >
          {{ translate("sim_server.update_status") }}
        </button>
      </div>

    </div>
    <div class="response_table remote_sims__table">
<!--      <div v-if="loading" style="height: 100%">-->
<!--        <h3 style="text-align: center">-->
<!--          {{ translate("no_data") }}-->
<!--        </h3>-->
<!--      </div>-->

      <table>
        <thead>
        <tr>
          <th scope="col">
            {{ translate("sim_server.simserver_name") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.simreader_name") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.sim_reader_slot") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.mno") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.imsi") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.iccid") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.device") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.device_slot") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.status") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.sim_status") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.sim_bind_status") }}
          </th>
          <th scope="col">
            {{ translate("sim_server.ts_update") }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(remote_sim, index) in remote_sim_list"
            :key="index"
            class="remote_sim_item"
            @click="show_info(remote_sim.id)"
        >
          <td :data-label="translate('sim_server.simserver_name')">
            <span>{{ remote_sim.sim_server_name }}</span>
          </td>
          <td :data-label="translate('sim_server.simreader_name')">
            <span>{{ remote_sim.sim_reader_name }}</span>
          </td>
          <td :data-label="translate('sim_server.sim_reader_slot')">
            <span>{{ remote_sim.sim_reader_slot }}</span>
          </td>
          <td :data-label="translate('sim_server.mno')">
            <span>{{ remote_sim.mno }}</span>
          </td>
          <td :data-label="translate('sim_server.imsi')" @click.stop="">
            <router-link :to="'/simcard_profile/' + remote_sim.imsi">
              <span>{{ remote_sim.imsi }}</span>
            </router-link>
          </td>
          <td :data-label="translate('sim_server.iccid')" @click.stop="">
            <router-link :to="'/simcard_devices_list?&msisdn_imsi_iccid=' + remote_sim.iccid">
              <span>{{ remote_sim.iccid }}</span>
            </router-link>
          </td>
          <td :data-label="translate('sim_server.device')" class="device_name" @click.stop="">
            <router-link :to="{path: '/device/' + remote_sim.device?.fid}">
              {{ remote_sim.device?.fid }}
            </router-link>
            <p>{{ remote_sim.device?.name }}</p>
          </td>
          <td
              :class="{
              device_online: remote_sim.device?.device_status === 1,
            }"
              :data-label="translate('sim_server.device_slot')"
          >
            <span>{{ remote_sim.device?.slot }}</span>
          </td>
          <td :data-label="translate('sim_server.status')">
            <span>{{ remote_sim.status }}</span>
          </td>
          <td :data-label="translate('sim_server.sim_status')">
            <span>{{ remote_sim.simcard_status }}</span>
          </td>
          <td
              class="binding"
              :data-label="translate('simcard_devices.binding')"
          >
            <span
                class="mdi fz16"
                :class="remote_sim.binding ? 'mdi-lock' : ''"
            />
            <span v-if="remote_sim.binding">
              {{
                remote_sim.bindingDevice.fid +
                "(" +
                remote_sim.binding.slot +
                ")"
              }}
            </span>
          </td>
          <td :data-label="translate('sim_server.ts_update')">
            <span>{{ get_date(remote_sim.ts_update) }}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import RemoteSimModal from "@/views/Dashboard/General/RemoteSim/Tabs/RemoteSimList/Modal/Index.vue";

export default {
  name: "RemoteSims",
  components: {},
  props: {},

  data() {
    return {
      loading: true,
      remote_sim_list: [],
      filter:{
        fid: "",
        iccid: ""
      },
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    };
  },

  created() {
    this.get_remote_sims();
  },

  methods: {
    change_input() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.get_remote_sims, 500);
    },
    get_remote_sims() {
      this.loading = true;
      let filter = {}
      Object.keys(this.filter).forEach((item) => {
        if (this.filter[item] && this.filter[item] !== ""){
          filter[item] = this.filter[item]
        }
      })
      this.$http.simcard.getRemoteSims(filter,(response) => {
        this.remote_sim_list = response.data.sort((a, b) =>
          a.ts_update < b.ts_update ? 1 : -1
        );
        this.loading = false;
      });
    },
    update_status() {
      this.$http.simcard.updateStatus((response) => {
        this.get_remote_sims();
      });
    },
    show_info(remote_sim_id) {
      let t = this.$createElement(RemoteSimModal, {
        props: {
          remote_sim_id: remote_sim_id,
        },
        on: {
          close: () => {
            this.$modal.hide("remote_sim_modal");
          },
          update: () => {
            this.get_remote_sims();
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
        temp,
        {},
        {
          height: "auto",
          width: 800,
          adaptive: true,
          clickToClose: true,
          name: "remote_sim_modal",
        }
      );
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  },
};
</script>
<style lang='scss' scoped>
.remote_sims {
  height: 100%;
  padding-top: 30px;
  display: flex;
  flex-direction: column;

  &__header{
    margin-bottom: 10px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex: 1;
    @media (max-width: 768px) {
      flex-direction: column;
    }
    .filters{
      width: 90%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      margin-right: 10px;
      @media (max-width: 768px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 10px;
        flex-direction: column;
      }
      .form_select{
        flex: 1;
        margin-right: 10px;
        @media (max-width: 768px) {
          width: 100%;
          margin-right: 0;
          margin-bottom: 5px;
        }
        &:last-child{
          margin-right: 0;
        }
        .form-group{
          margin: 0;
        }
      }
    }
    .buttons{
      display: flex;
      flex-direction: column;
      @media (max-width: 768px) {
        width: 100%;
      }
      .btn{
        margin-bottom: 5px;
        height: 40px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
  }

  &__table{
    padding: 0;
    flex: 11;
    .remote_sim_item{
      &:hover{
        cursor: pointer;
        background-color: #eaeaea;
      }
      .device_name{
        a,p{
          font-size: 10px;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
